document.addEventListener("DOMContentLoaded", function() {

  const sections = document.querySelectorAll("body.index .shopify-section.section");

  sections.forEach(section => {

    section.addEventListener("click", function(e) {

      // Evita que afecte botones o links internos
      if (e.target.closest("a, button")) return;

      // Tu URL destino
      window.location.href = "https://www.instagram.com/thegoldenpavlova/";

    });

  });

});